import React from "react";
import { Box, Chip, Paper } from "@mui/material";
import { truncate } from "helpers/truncate";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import QuizIcon from "@mui/icons-material/Quiz";
import { useNavigate, useHref } from "react-router-dom";
const ClassRoomItems = ({ type, courseTitle, lessonId, item }) => {
  const description = truncate(item.description, 30);
  const navigate = useNavigate();
  const isCurrentItem = parseInt(lessonId) === item.id;

  const courseTitleToUrl = courseTitle.replace(/ /g, "-").toLowerCase();
  const route = useHref(
    `/course/classroom/${courseTitleToUrl}/${type}/${item.id}`
  );

  const getIcon = () => {
    if (type === "clase") {
      return <PlayCircleOutlineIcon sx={{ fontSize: 24, color: isCurrentItem ? "#fff" : "#1976d2" }} />;
    } else {
      return <QuizIcon sx={{ fontSize: 24, color: isCurrentItem ? "#fff" : "#1976d2" }} />;
    }
  };

  const getTypeLabel = () => {
    return type === "clase" ? "Lección" : "Quiz";
  };

  return (
    <Paper
      elevation={isCurrentItem ? 4 : 1}
      sx={{
        margin: "8px 16px",
        padding: "12px",
        borderRadius: "12px",
        cursor: "pointer",
        backgroundColor: isCurrentItem ? "#1976d2" : "#fff",
        color: isCurrentItem ? "#fff" : "inherit",
        transition: "all 0.2s ease-in-out",
        border: isCurrentItem ? "none" : "1px solid #e0e0e0",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 4,
          backgroundColor: isCurrentItem ? "#1565c0" : "#f5f5f5",
        },
      }}
      onClick={() => {
        navigate(route);
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: isCurrentItem ? "rgba(255,255,255,0.2)" : "rgba(25,118,210,0.1)",
          }}
        >
          {getIcon()}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              marginBottom: 0.5,
            }}
          >
            <Chip
              label={getTypeLabel()}
              size="small"
              variant={isCurrentItem ? "outlined" : "filled"}
              sx={{
                fontSize: "0.7rem",
                height: 20,
                backgroundColor: isCurrentItem ? "transparent" : "#e3f2fd",
                color: isCurrentItem ? "#fff" : "#1976d2",
                border: isCurrentItem ? "1px solid rgba(255,255,255,0.7)" : "none",
              }}
            />
          </Box>
          <Box
            sx={{
              fontWeight: isCurrentItem ? 600 : 500,
              fontSize: "0.9rem",
              marginBottom: 0.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {item.name}
          </Box>
          {description && (
            <Box
              sx={{
                fontSize: "0.75rem",
                opacity: isCurrentItem ? 0.9 : 0.7,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {description}
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default ClassRoomItems;
